module.exports = __webpack_public_path__ + "img/55.bc1829e7.jpg";